export default __webpack_public_path__ + "static/media/ico-gallery.b2463294.svg";